export enum DispatchActivityEventType {
  EngineStarted = 'ENGINE_STARTED',
  RuleMatched = 'RULE_MATCHED',
  NoFleetsFound = 'NO_FLEETS_FOUND',
  FleetNotified = 'FLEET_NOTIFIED',
  FleetAccepted = 'FLEET_ACCEPTED',
  FleetRejected = 'FLEET_REJECTED',
  ResponseTimeout = 'RESPONSE_TIMEOUT',
  AllFleetsRejected = 'ALL_FLEETS_REJECTED',
  MovedToMarketplace = 'MOVED_TO_MARKETPLACE',
  SlaBreach = 'SLA_BREACH',
}
